import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {NewsApiModel} from "./news.api-model";
import {NewsSourceDomainModel} from "./news-source.domain-model";

export class NewsDomainModel extends BaseDomainModel {
  apiModel: NewsApiModel;
  title: String;
  image: String;
  source: NewsSourceDomainModel;
  publishDate: Date;
  url: String;
  isMagazine: Boolean;

  constructor(apiModel: NewsApiModel, source: NewsSourceDomainModel, date: Date) {
    super(apiModel);

    this.title = apiModel.title;
    this.image = apiModel.image;
    this.source = source;
    this.publishDate = date;
    this.url = apiModel.url;
    this.isMagazine = apiModel.isMagazine;
  }
}